const keys = {
	nodeENV: process.env.REACT_APP_NODE_ENV,
	baseApiUrl: process.env.REACT_APP_WEEAM_LOCAL_API,
	productApiUrl:process.env.REACT_APP_CRM_PRODUCT_API_URL,
	hiringFormUrl:process.env.REACT_APP_HIRING_FORM_URL,
	// server2: process.env.REACT_APP_SERVER2,
	wssSocketUrl: process.env.REACT_APP_SOCKET_WSS_API,
	socketUrl: process.env.REACT_APP_SOCKET_API,
	clientUrl: process.env.REACT_APP_CLIENT_URL,

	version: process.env.REACT_APP_RELEASE_VERSION,

	// c: process.env.REACT_APP_FB_PIXEL_API,
	// fbPixelId: process.env.REACT_APP_FB_PIXEL_ID,
	// fbPixelToken: process.env.REACT_APP_FB_PIXEL_TOKEN,

	socketIoUrl: process.env.REACT_APP_SOCKET_IO_URL,
	sipApiUrl: process.env.REACT_APP_SIP_BASE_URL,
	sipApiUrl2: process.env.REACT_APP_SIP_SERVER_2_BASE_URL,
};

export default keys;
